import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=b954d892&scoped=true"
import script from "./finish.vue?vue&type=script&lang=js"
export * from "./finish.vue?vue&type=script&lang=js"
import style0 from "./finish.vue?vue&type=style&index=0&id=b954d892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b954d892",
  null
  
)

export default component.exports